import { c as _c } from "react/compiler-runtime";
import { TelesalesAppName } from "@website/widget/telesales";
import { useRouter } from "next/router";
import { description, reasonsSchema, storageKey } from "../constant/telesales";
export const useTelesales = () => {
  const $ = _c(5);
  const {
    query
  } = useRouter();
  const {
    stDate,
    rtDate,
    origin,
    dest
  } = query;
  const t0 = stDate as string;
  const t1 = rtDate as string;
  const t2 = origin as string;
  const t3 = dest as string;
  let t4;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3) {
    t4 = {
      teleSalesData: {
        requestData: {
          app: "tour" as TelesalesAppName,
          checkin: t0,
          checkout: t1,
          city_from: t2,
          city_to: t3,
          city_id: 0,
          hotel_id: 0,
          funnel: "telesales_box"
        },
        description,
        reasons: reasonsSchema,
        storageKey
      }
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};